__turbopack_context__.v({
  "benefitEntry": "styles-module-scss-module__Vvwc9q__benefitEntry",
  "benefitText": "styles-module-scss-module__Vvwc9q__benefitText",
  "benefits": "styles-module-scss-module__Vvwc9q__benefits",
  "cv": "styles-module-scss-module__Vvwc9q__cv",
  "isMyProfile": "styles-module-scss-module__Vvwc9q__isMyProfile",
  "link": "styles-module-scss-module__Vvwc9q__link",
  "manualCvPaper": "styles-module-scss-module__Vvwc9q__manualCvPaper",
  "manualText": "styles-module-scss-module__Vvwc9q__manualText",
  "manualTitle": "styles-module-scss-module__Vvwc9q__manualTitle",
  "paper": "styles-module-scss-module__Vvwc9q__paper",
  "show": "styles-module-scss-module__Vvwc9q__show",
  "unfold": "styles-module-scss-module__Vvwc9q__unfold",
  "upload": "styles-module-scss-module__Vvwc9q__upload",
  "uploadCvPaper": "styles-module-scss-module__Vvwc9q__uploadCvPaper",
  "uploadIntro": "styles-module-scss-module__Vvwc9q__uploadIntro",
  "uploadStatusContainer": "styles-module-scss-module__Vvwc9q__uploadStatusContainer",
  "uploadSubtitle": "styles-module-scss-module__Vvwc9q__uploadSubtitle",
  "uploadTitle": "styles-module-scss-module__Vvwc9q__uploadTitle",
});
